import React from "react";
import "./PublishingComparison.css";


function PublishingComparison() {
    const publishingData = {
        headers: ["자비 출판", "반기획 출판", "기획 출판"],
        rows: [
            { label: "비용 부담",   values: ["저자 부담",              "저자·출판사 분담", "출판사 부담"] },
            { label: "수익 분배",   values: ["저자 중심\n(정가의 50%)", "저자·출판사 분배", "저자 인세 지급 \n(정가의 10%)"] },
            { label: "진행 주체",   values: ["저자 중심",              "공동 진행",       "출판사 중심"] },
            { label: "출판사 역할", values: ["제작·유통 대행",          "기획·제작 협업",   "전 과정 주도"] },
            { label: "예상 비용",   values: ["100만 원~",             "400~500만 원",    "저자 부담 없음"] },
        ]
    }

    const amazonData = {
        header: "아마존 킨들 출판",
        values: ["전문 번역, 편집, 표지 디자인", "전자책, (POD) 동시 출판 가능", "저자 인세 100% \n(전자책 최대 70%, 종이책 60%)", "전 세계 12개국 아마존 마켓 자동 노출"]
    }

    return (
        <div className="pub-comp">
            <div className="comp-table">
                <div className="comp-label-cell empty" />
                {publishingData.headers.map((header, i) => (
                    <div key={i} className={`comp-header-cell ${["self", "shared", "planned"][i]}`}>
                        {header}
                    </div>
                ))}

                {publishingData.rows.map((row, i) => (
                    <React.Fragment key={i}>
                        <div className={`comp-label-cell ${i === 0 ? "top-left" : i === publishingData.rows.length - 1 ? "bottom-left" : ""}`}>
                            {row.label}
                        </div>
                        {row.values.map((value, j) => (
                            <div key={j} className="comp-value-cell">
                                {value}
                            </div>
                        ))}
                    </React.Fragment>
                ))}
            </div>

            <div className="comp-kindle">
                <div className="comp-kindle-header">
                    {amazonData.header}
                </div>
                
                <div className="comp-kindle-values">
                {amazonData.values.map((value, i) => (
                    <div key={i} className="comp-kindle-value">· {value}</div>
                ))}
                </div>
            </div>
        </div>
    );
}

export default PublishingComparison;